<template>
    <v-row 
      justify="center">
        <div v-if="withArrs" class ="arrs" id="moveWeekLeft" @click="leftArrFunction">&larr;</div>
        <span v-else></span>
        <div class="datedataweek" v-for="(days,key) in weekdatesdatas">
            <v-col :id="days.dayid" @click="dayFunction(days.dayid)" class="">
                <p >
                    <div class="daycell dayname">{{ days.dayhead }}</div>
                    <div :class="days.showdaycss" :id="'wp'+days.dayid" class="daycell daynb">{{ days.daynb }}</div>
                </p>
                <span v-if="days.showdaycss != ''">
                    <span class="showdayspan"></span>
                </span>
            </v-col>
        </div>
        <div v-if="withArrs" class ="arrs" id="moveWeekRight" @click="rightArrFunction">&rarr;</div>
        <span v-else></span>
    </v-row>
  </template>
  <script>
    export default {
     props: {
        weekdatesdatas: Object,
        withArrs: Boolean,
        leftArrFunction: Function,
        rightArrFunction: Function,
        withDaySelect: Boolean,
        dayFunction: Function,
        daybefore: String
     },
    }
  </script>
<style>
.datedataweek{
    max-width: 50px;
}
.daycell{
    min-width:17px;
    min-height:20px;
    text-align: center;
}
.dayname{
    color: #777777;
    font-size: 9px;
}
.daynb{
    font-size: 12px;
}
.showday{
    z-index: 2;
    position: relative;
}
.showdayspan{
    background-image: url('../../assets/dayToday.png');
    background-size: contain;
    background-position-x: center;
    width: 30px;
    height: 39px;
    display: block;
    position: absolute;
    margin-top: -23px;
    z-index: 0;
    margin-left: -3px;
}
.arrs{
    margin-top: auto;
    margin-bottom: auto;
}
</style>